import React, { useRef, useState, MouseEvent } from 'react';
import twttr from 'twitter-text';

import PostTweetModal from 'buyside/components/presentation/Twitter/PostTweet/postTweetModal';
import {
  charLimit,
  warningThreshold
} from 'buyside/components/presentation/Twitter/PostTweet/wordCounter';

import styles from 'buyside/components/presentation/Twitter/twitterStyles.scss';

const HighlightText = ({ children }: { children: React.ReactNode }): React.ReactElement => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const [selectedText, setSelectedText] = useState<string>('');

  const onHighlight = (e: MouseEvent<HTMLDivElement>): void => {
    e.preventDefault();
    const selection = window.getSelection();
    if (
      selection?.toString() &&
      selection.toString() !== selectedText &&
      buttonRef.current &&
      containerRef.current
    ) {
      setSelectedText(selection.toString());

      const buttonApproxDiameter = 30;
      const containerBounds = containerRef.current.getBoundingClientRect();
      const highlightBounds = selection.getRangeAt(0).getBoundingClientRect();
      const leftVal = highlightBounds.left - containerBounds.left + highlightBounds.width;
      const topVal = highlightBounds.top - containerBounds.top - buttonApproxDiameter;

      buttonRef.current.style.left = `${
        leftVal + buttonApproxDiameter < containerBounds.width
          ? leftVal
          : leftVal - buttonApproxDiameter
      }px`;
      buttonRef.current.style.top = `${
        topVal > 0 ? topVal : topVal + highlightBounds.height + buttonApproxDiameter
      }px`;
    }
  };

  const weightedLength = twttr.parseTweet(selectedText).weightedLength;

  return (
    <div className={styles.highlightContainer} ref={containerRef}>
      <div className={styles.highlightButtonContainer} ref={buttonRef}>
        {selectedText && (
          <PostTweetModal
            colorClass={
              weightedLength > charLimit
                ? styles.error
                : weightedLength >= warningThreshold
                ? styles.warning
                : null
            }
            forHighlight
            initialTweetMsg={selectedText}
            buttonTitle={`Post A Tweet • ${
              weightedLength <= charLimit
                ? `${charLimit - weightedLength} characters remaining`
                : `Character limit exceeded by ${weightedLength - charLimit}`
            }`}
          />
        )}
      </div>
      <div onMouseUp={onHighlight} className={styles.highlightTextContainer}>
        {children}
      </div>
    </div>
  );
};

export default HighlightText;
